import FeaturePage from "../../components/FeaturePage";
import { Workflow, Mail, RefreshCw, Truck, Bell, GitBranch } from "lucide-react";

export default function AutomateOrders() {
  return (
    <FeaturePage
      badge="Automate Order Processes"
      title="Let the boring stuff."
      highlight="Run itself."
      subtitle="Stock updates, customer emails, delivery notifications — Brivo's workflow engine handles repetitive tasks so your team can focus on what matters."
      heroImage="https://images.unsplash.com/photo-1766430342829-9896223959db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="pink"
      features={[
        { icon: <Workflow size={22} />, title: "Visual workflows", desc: "Build automations with a drag-and-drop builder. No code, no fuss." },
        { icon: <Mail size={22} />, title: "Auto emails & SMS", desc: "Order confirmations, shipping updates, follow-ups, all on autopilot." },
        { icon: <RefreshCw size={22} />, title: "Stock auto-updates", desc: "Inventory adjusts instantly across POS, online store, and integrations." },
        { icon: <Truck size={22} />, title: "Shipping triggers", desc: "Auto-create shipments, print labels, send tracking links." },
        { icon: <Bell size={22} />, title: "Smart alerts", desc: "Notifications for low stock, big orders, refund requests, and more." },
        { icon: <GitBranch size={22} />, title: "Conditional logic", desc: "If/then rules — e.g. 'if order > $500, alert manager and require approval'." },
      ]}
      details={[
        {
          tag: "Workflows",
          title: "Automate any process, in minutes.",
          desc: "Build the workflows your business actually needs — from new-order routing to refund approvals — using a clean visual canvas. No engineers required.",
          bullets: ["Drag-and-drop builder", "200+ pre-built templates", "Branch & merge logic"],
        },
        {
          tag: "Communications",
          title: "Talk to customers without lifting a finger.",
          desc: "Trigger personalized emails and SMS based on any event — order placed, payment received, item shipped, review requested.",
          bullets: ["Branded email templates", "Two-way SMS conversations", "Automated review collection"],
        },
        {
          tag: "Integrations",
          title: "Connect Brivo to the tools you already love.",
          desc: "Native integrations with Shopify, WooCommerce, Mailchimp, Slack, Zapier, and 5,000+ apps via webhooks.",
        },
      ]}
      useCases={[
        { title: "Order routing", desc: "Auto-assign orders to the closest branch." },
        { title: "Refunds", desc: "Multi-step approval flows with audit logs." },
        { title: "Marketing", desc: "Drip campaigns triggered by purchase behavior." },
        { title: "Logistics", desc: "Auto-pick carriers based on weight & destination." },
      ]}
      ctaTitle="Stop doing it by hand."
      ctaSubtitle="Automate the boring 80% so you can focus on the exciting 20% — growth."
      ctaAccent="mint"
    />
  );
}
